export const genericStringComparator = (associationsA: string, associationsB: string): number => {
    if (associationsA === associationsB) return 0;
    return associationsA > associationsB ? 1 : -1;
};
